import { autobind } from "@typed-decorators/autobind";
import gql from "graphql-tag";
import type { ReactNode } from "react";
import { Component } from "react";

import { client } from "../utils/kibelaClient2";

import { KibelaSymbol } from "./shared/kibela_symbol";

const CloseAnnouncement = gql`
  mutation CloseAnnouncement($announcementKey: String!) {
    closeAnnouncement(input: { announcementKey: $announcementKey }) {
      clientMutationId
    }
  }
`;

interface Props {
  messageHtml: string | null;
  announcementKey: string | null;
  announcementType: "warning" | "notice";
  children?: ReactNode;
}

interface State {
  isClosed: boolean;
}

export class AnnounceBox extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      isClosed: false,
    };
  }

  @autobind
  async handleClose() {
    this.setState({ isClosed: true });

    try {
      await client.mutate({
        mutation: CloseAnnouncement,
        variables: { announcementKey: this.props.announcementKey },
      });
    } catch (reason) {
      // ignore errors here because there's no way to do it.
      // this announcement may be open on the next visiting, but the user can close it again.
    }
  }

  render() {
    if (this.state.isClosed) {
      return null;
    }

    return (
      <div className={`announceBox is-${this.props.announcementType}`}>
        {this.props.announcementType === "warning" && <KibelaSymbol id="error" />}

        <div className="announceBox-message">
          {this.props.messageHtml ? (
            <div dangerouslySetInnerHTML={{ __html: this.props.messageHtml }} />
          ) : (
            this.props.children
          )}
        </div>

        {this.props.announcementKey && (
          <button type="button" className="announceBox-close" onClick={this.handleClose}>
            <KibelaSymbol id="close" />
          </button>
        )}
      </div>
    );
  }
}
